import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBackOfficeStopDetails extends Layout {
    sourceStop: DataSource;
    tableStopDetails: Table;
}
